import React from 'react';
import parse from 'html-react-parser';

export interface AccordionProps {
  id: string | number
  headline: string
  paragraph: string
  showContent: string | null
  handleAccordionClick: ( id: string ) => void
}

const Accordion = (props: AccordionProps) => {
	const { headline, paragraph, id, showContent, handleAccordionClick } = props;
	const contentRef = React.useRef<HTMLDivElement>(null);
	const [rollOutHeight, setRollOutHeight] = React.useState(0);

	React.useEffect(()=>{
		if (contentRef.current && contentRef.current.children){
			const childArray = Array.from(contentRef.current.children) as HTMLElement[];
			const height = childArray.reduce((totalHeight: number, child) => {
				return totalHeight + child.offsetHeight;
			}, 0);

			setRollOutHeight(height ? height + 30 : 0 );
		}
	}, [contentRef.current]);

	return (
		<div className="accordion">
			<div className="accordion-container">
				<div className={ `accordion-header ${showContent === id.toString() ? 'accordion-open' : ''}` } onClick={ () => handleAccordionClick(id.toString()) }>
					{ headline }
					<div className="accordion-bubble" />
				</div>
				<div className={ `accordion-content ${showContent === id.toString() ? 'accordion-open' : ''}` } ref={ contentRef } style={ (showContent === id.toString() && rollOutHeight) ? { height: rollOutHeight } : {} }>
					{ parse(paragraph) }
				</div>
			</div>
		</div>
	);
};

export default Accordion;